export function convertToUTCMidday(date: Date) {
  date.setUTCFullYear(date.getFullYear(), date.getMonth(), date.getDate());
  date.setUTCHours(12, 0, 0, 0);

  return date;
}
